export default "__VITE_ASSET__CaDUwq2K__"